<wvre-text-node>{{value}}</wvre-text-node>
